import {buildValidator} from "./validation";

function emailValidator () {
    return function email (value) {
        return (value && !!value.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/))
            || 'Please enter a valid email'
    }
}

function requiredValidator () {
    return function required (value) {
        return (value !== undefined && value !== null && value !== '') || 'This field is required'
    }
}

function requiredArrayValidator () {
    return function required (value) {
        return (value !== undefined && value !== null && value.length > 0) || 'This array must not be empty'
    }
}

function phoneNumberValidator () {
    return function phoneNumber (value) {
        return (value && !!value.match(/^((\+|00(\s|\s?\-\s?)?)31(\s|\s?\-\s?)?(\(0\)[\-\s]?)?|0)[1-9]((\s|\s?\-\s?)?[0-9])((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]$/))
            || 'Please enter a valid phone number'
    }
}

function kvkValidator() {
    return function kvk (value) {
        return (value && !!value.match(/^(\d{8})$/))
            || 'Please enter a valid kvk number'
    }
}

function branchValidator() {
    return function branch (value) {
        return (value === undefined || value === '' || value === null || !!value.match(/^(\d{12})$/))
            || 'Please enter a valid kvk number'
    }
}

function postCodeValidator() {
    return function postCode (value) {
        return (value && !!value.match(/^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-zA-Z]{2}$/))
            || 'Please enter a valid kvk number'
    }
}

function lettersOnlyValidator() {
    return function postCode (value) {
        return (value && !!value.match(/^[a-zA-Z\s]*$/))
            || 'Please enter a valid kvk number'
    }
}

function dateValidator() {
    return function date (value) {
        if(!isDateFormat(value)) {
            return 'Please enter a date'
        }
        let today = new Date()
        let input = new Date(value)
        return (input.getTime() <= today.getTime())
            || 'Please enter a date in the past'
    }
}

function futureDateValidator() {
    return function date (value) {
        if(!isDateFormat(value)) {
            return 'Please enter a date'
        }
        let futureDate = new Date(Date.now() + 1000 /*sec*/ * 60 /*min*/ * 60 /*hour*/ * 24 /*day*/ * 60)
        let input = new Date(value)
        return (input.getTime() > futureDate.getTime())
            || 'Please enter a date at least 2 months in the future'
    }
}

function isDateFormat(date) {
    return !!date.match(/^([0-9]{4}-[0-9]{2}-[0-9]{2})$/)
}

export function conditionedRequiredValidator(applyIfTrue) {
    return buildConditionalValidator(applyIfTrue, requiredValidator())
}

export const emailFieldValidator = buildValidator(requiredValidator(), emailValidator())
export const requiredFieldValidator = buildValidator(requiredValidator())
export const requiredArrayFieldValidator = buildValidator(requiredArrayValidator())
export const phoneNumberFieldValidator = buildValidator(requiredValidator(), phoneNumberValidator())
export const kvkFieldValidator = buildValidator(requiredValidator(), kvkValidator())
export const branchFieldValidator = buildValidator(branchValidator())
export const postCodeFieldValidator = buildValidator(requiredValidator(), postCodeValidator())
export const lettersOnlyFieldValidator = buildValidator(requiredValidator(), lettersOnlyValidator())
export const dateFieldValidator = buildValidator(requiredValidator(), dateValidator())
export const futureDateFieldValidator = buildValidator(requiredValidator(), futureDateValidator())